import { render, staticRenderFns } from "./Vistoria.vue?vue&type=template&id=018bb61e&"
import script from "./Vistoria.vue?vue&type=script&lang=js&"
export * from "./Vistoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports